module.exports = __webpack_public_path__ + "static/monash-logo-13662ef9e4598a58e9424299c5549381.png";